if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        this.destroyModalVideoAutoplay();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initModalVideoAutoplay();
        this.showActiveMedia();
      }

      initModalVideoAutoplay() {
        this.destroyModalVideoAutoplay();
        const container = this.querySelector('[role="document"]');
        if (!container) return;

        const deferredMediaFromTarget = (target) => {
          if (!target) return null;
          if (target.nodeName === 'DEFERRED-MEDIA') return target;
          return target.querySelector && target.querySelector('deferred-media');
        };

        const visibleEnoughInScrollRoot = (entry) => {
          if (!entry.isIntersecting) return false;
          const h = entry.intersectionRect.height;
          const w = entry.intersectionRect.width;
          const rootH = container.clientHeight || 0;
          // Tall blocks get a low intersectionRatio while still clearly on screen; use pixels + ratio.
          return (
            (h >= 120 && w >= 120) ||
            entry.intersectionRatio >= 0.25 ||
            (rootH > 0 && h >= rootH * 0.2)
          );
        };

        this.modalVideoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const deferredMedia = deferredMediaFromTarget(entry.target);
              if (!deferredMedia) return;
              if (visibleEnoughInScrollRoot(entry)) {
                deferredMedia.loadContent(false, true, true);
              }
            });
          },
          { root: container, rootMargin: '0px', threshold: [0, 0.05, 0.1, 0.2, 0.35, 0.5, 0.75] },
        );

        Array.from(container.children).forEach((child) => {
          if (deferredMediaFromTarget(child)) {
            this.modalVideoObserver.observe(child);
          }
        });
      }

      destroyModalVideoAutoplay() {
        if (this.modalVideoObserver) {
          this.modalVideoObserver.disconnect();
          this.modalVideoObserver = null;
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        const deferredMedia =
          activeMedia.nodeName === 'DEFERRED-MEDIA'
            ? activeMedia
            : activeMedia.querySelector && activeMedia.querySelector('deferred-media');
        if (deferredMedia) {
          deferredMedia.loadContent(false, true, true);
          window.setTimeout(() => deferredMedia.loadContent(false, true, true), 320);
        }
      }
    }
  );
}
